module.exports = __webpack_public_path__ + "static/media/Poppins-Bold-700.5db3d2b3.ttf";